/*
 * DEPRECATED!
   Do not bother to modify. 
   Common indicators have changed & this component doesn't work. 
   Kept to keep some old forms loadable.   

 * Common indicator selection component
 */

import React from 'react';
import Base from './base.jsx'; 
import {
    castDataType,
    DataType,
} from '../common.jsx';
import Helpers from './helpers.jsx'
import Setting from "./setting.jsx";

import TextField from './text_field.jsx'

import { result_framework_list_common_indicators_for_programme_path } from '~/routes';

export default class AdaliaMECommonIndicator extends Base {
    static get TYPE() {
        return 'adalia_me_common_indicator';
    }
    static get CATEGORY() {
        return 'other';
    }
    static icon(){
        return <i className="fa fa-pencil-square-o"></i>;
    }
    static get TRANSLATED_ATTRIBUTES() {
        return {
            label: 'field_default_label',
            placeholder: 'field_default_placeholder',
            description: 'field_default_description',
            help: null
        };
    }
    static defaultContent(language) {
        let fieldName = 'field_' + Helpers.randomString();
        return Object.assign(super.defaultContent(language), {
            name: fieldName,
            required: false,
            label_hidden: false,
            cloneable: true,
            deletable: true,
            sortable: false
        });
    }
    constructor(props) {
        super(props);
        this.state = {
            indicators: []
        }
    }
    renderView() {
        let indicator = (this.state.indicators || []).find((i)=>i.root_indicator_id == this.props.content.commonIndicatorId)
        return (
            <div>
                <label>
                    <AdaliaMECommonIndicatorDescription 
                        content={this.props.content} 
                        mode = {this.props.mode}
                        fieldScope = 'form'
                        answers = {this.props.answers}
                        selectCallback = {this.props.selectCallback}/>
                    <table className='table indicator-values common-indicator-values'>
                        <thead>
                            <tr>
                                <th>{I18n.t('indicator')}</th>
                                <th>{I18n.t('baseline')}</th>
                                <th>{I18n.t('target')}</th>
                                <th>{I18n.t('new_value')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                indicator ? 
                                indicator.indicators.map((i, index) => {
                                    let content = i;
                                    content.name = this.props.content.name;
                                    return (
                                        <tr key={i.id}>
                                            <td style={{paddingLeft:10*(i.level+1)}}>
                                                {i.disaggregation ? <span className='label label-info disaggregation' style={{backgroundColor: '#5bc0de'}} title = {i.disaggregation}>{i.disaggregation}</span> : null}
                                                {i.title || '-'}
                                            </td>
                                            <td>{i.baseline_value || '-'}</td>
                                            <td>{i.target_value || '-'}</td>
                                            <td className='indicator-value-field'>
                                                <AdaliaMECommonIndicatorField 
                                                    content = {content}
                                                    parentCommonIndicatorId = {this.props.content.commonIndicatorId}
                                                    name = {this.props.content.name}
                                                    indicatorId = {i.id}
                                                    mode = {this.props.mode}
                                                    fieldScope = 'form'
                                                    answers = {this.props.answers}
                                                    selectCallback = {this.props.selectCallback}
                                                />
                                            </td>
                                            <td>{i.unit || ''}</td>
                                        </tr>
                                    )
                                    }
                                )
                                : null
                            }
                        </tbody>
                    </table>
                </label>
            </div>
        );
    }

    renderSettings() {
        let indicatorOptions = (this.state.indicators || []).map((i) => [i.root_indicator_id, i.root_indicator_title])
        return (
            <div>
                <Setting.Checkbox name="required" label={I18n.t('field_required', {scope: 'fe'})} value={this.props.content.required} onChange={this.updateSettings} />
                <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
                <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
                <Setting.Dropdown name="commonIndicatorId" label={I18n.t('field_common_indicator', {scope: 'fe'})} value={this.props.content.commonIndicatorId} onChange={this.updateSettings} options={indicatorOptions}/>
            </div>
        )
    }

    componentDidMount(){
        console.warn("DEPRECATED - Do not use. Kept to keep some old forms working.")
        super.componentDidMount();
        const url = result_framework_list_common_indicators_for_programme_path();
        jQuery.getJSON(url, data => {
            this.setState({
                indicators: data.common_indicators
            })
        })
    }

    componentWillUnmount() {
        this.setState = ()=>{
            return;
        };
    }

    beforeUpdateSettings(content) {
        content.required = castDataType(content.required, DataType.BOOLEAN);
        content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
    }

}

class AdaliaMECommonIndicatorField extends TextField {
    static get TYPE() {
        return 'adalia_me_common_indicator_field';
    }
    static get TRANSLATED_ATTRIBUTES() {
        return {
            label: 'field_default_label',
            placeholder: 'field_default_placeholder',
            description: 'field_default_description',
            help: null
        };
    }
    static defaultContent(language) {
        return Object.assign(super.defaultContent(language), {
            name: 'adalia_me_common_indicator_field',
            required: false,
            cloneable: false,
            deletable: false,
            sortable: false
        });
    }
    fullFieldName(){
        return super.fullFieldName() + '[common_indicators][' + this.props.parentCommonIndicatorId + ']' +'[values]['+ this.props.indicatorId +']';
    }
}

export class AdaliaMECommonIndicatorDescription extends TextField {
    static get TYPE() {
        return 'adalia_me_common_indicator_description';
    }
    static get TRANSLATED_ATTRIBUTES() {
        return {
            label: 'Description',
            placeholder: 'field_default_placeholder',
            description: 'field_default_common_indicator_value_record_description',
            help: null,
            unit: null
        };
    }
    static defaultContent(language) {
        return Object.assign(super.defaultContent(language), {
            name: 'adalia_me_common_indicator_description',
            required: false,
            cloneable: false,
            deletable: false,
            sortable: false
        });
    }
    fullFieldName() {
        return  super.fullFieldName() + '[common_indicators][' + this.props.content.commonIndicatorId + ']' +'[description]';
    }
}